export default __webpack_public_path__ + "static/media/pizza.21a1098f.jpeg";